@if (loading) {
  <mat-progress-bar
    style="position: static; z-index: 1; left: 0; right: 0; top: 50px; bottom: 0"
    mode="query"
    >
  </mat-progress-bar>
}
<h3
  mat-dialog-title
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
  >
  {{ data.title }}
</h3>
<div mat-dialog-content>
  <form class="customer-form" #firmwareForm="ngForm" (ngSubmit)="onSubmit()">
    <mat-form-field>
      <textarea
        matInput
        placeholder="Firmware Version"
        required
        [(ngModel)]="firmwarePost.firmwareVersion"
        name="firmwareVersion"
      ></textarea>
    </mat-form-field>
    <!-- <mat-form-field>
    <input
      matInput
      placeholder="Firmware Name"
      type="text"
      required
      [(ngModel)]="firmwarePost.name"
      name="name"
      />
  </mat-form-field> -->
  <mat-form-field>
    <mat-select matInput placeholder="Instance" required [(ngModel)]="firmwarePost.firmwareInstanceId"
      name="instance">
      @for (inst of instances | sort:'key'; track inst) {
        <mat-option [value]="inst.value">
          {{ inst.key }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Firmware Begins"
      type="text"
      required
      [(ngModel)]="firmwarePost.whenBegin"
      name="whenBegin"
      />
  </mat-form-field>
  <!-- <mat-form-field>
  <input
    matInput
    placeholder="Firmware Begins"
    type="text"
    required
    [(ngModel)]="firmwarePost.whenEnd"
    name="whenEnd"
    />
</mat-form-field> -->
<button
  mat-raised-button
  type="submit"
  [disabled]="!firmwareForm.form.valid"
  color="primary"
  style="max-width: min-content"
  >
  Create
</button>
</form>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="close"
    (click)="onNoClick()"
    color="warn"
    style="max-width: min-content"
    >
    Cancel
  </button>
</div>
